import { render, staticRenderFns } from "./ui-answer.vue?vue&type=template&id=60b2ba66&scoped=true"
import script from "./ui-answer.vue?vue&type=script&lang=js"
export * from "./ui-answer.vue?vue&type=script&lang=js"
import style0 from "./ui-answer.vue?vue&type=style&index=0&id=60b2ba66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2ba66",
  null
  
)

export default component.exports